module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c(_vm.el, {
    tag: "component",
    attrs: {
      "label": _vm.label,
      "align": _vm.align,
      "prop": _vm.prop,
      "required": _vm.required
    }
  }, [(_vm.noForm && _vm.showLabel) ? _c('span', [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), (!_vm.disabled) ? _c('el-input', {
    attrs: {
      "type": _vm.type,
      "align": _vm.alignInput,
      "size": _vm.size,
      "disabled": _vm.disabled,
      "pattern": _vm.pattern,
      "autosize": _vm.type === 'textarea' ? {
        minRows: 2,
        maxRows: _vm.rows
      } : null,
      "step": _vm.type === 'number' ? (_vm.decimals > 0 ? _vm.stepValue : '1') : 'any',
      "rows": _vm.rows,
      "placeholder": _vm.placeholder ? _vm.placeholder : _vm.label
    },
    on: {
      "change": _vm.updated
    },
    model: {
      value: (_vm.formData),
      callback: function($$v) {
        _vm.formData = $$v
      },
      expression: "formData"
    }
  }, [(_vm.prefix) ? _c('template', {
    slot: "prepend"
  }, [(_vm.isPrefixIcon) ? _c('i', {
    class: _vm.prefix
  }) : _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.prefix)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.suffix) ? _c('template', {
    slot: "append"
  }, [(_vm.isSuffixIcon) ? _c('i', {
    class: _vm.suffix
  }) : _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.suffix)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.appendIconButton) ? _c('el-button', {
    attrs: {
      "slot": "append",
      "on-icon-click": _vm.onButtonClick,
      "icon": _vm.appendIconButton
    },
    slot: "append"
  }) : _vm._e()], 2) : _c('span', [(_vm.prefix) ? _c('span', [(_vm.isPrefixIcon) ? _c('i', {
    class: _vm.prefix
  }) : _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.prefix)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.type === 'number') ? _c('b', [_vm._v(_vm._s(this.formatNumber(this.formData, this.decimals)))]) : _c('b', {
    domProps: {
      "innerHTML": _vm._s(this.formData)
    }
  }), _vm._v(" "), (_vm.suffix) ? _c('span', [(_vm.isSuffixIcon) ? _c('i', {
    class: _vm.suffix
  }) : _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.suffix)
    }
  })]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-db9080ce"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/atoms/inputs/TextInput.vue
// module id = 1638
// module chunks = 0